import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../../../core/auth/auth.service';
import {NotifyService} from '@services/notify.service';
import {getIdentifierAutomatizedTest, getIdentifierTestQa} from '../../../../../core/auth/automated-test-identifier';
import {GenericButtonProperties} from '@shared/components/button/generic-button-v2/generic-button-v2.component';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['../../login.component.scss'],
    standalone: false
})
export class WelcomeComponent implements OnInit {

  @ViewChild('inputIdentify') inputIdentify!: ElementRef;

  public isAtendimentoRoute = false;
  public isTestEnv = false;
  public isLoading = false;

  public get buttonLogin(): GenericButtonProperties {
    return {
      label: 'Já sou cadastrado',
      classIcon: 'ico-login',
      iconPosition: 'left',
      idHtml: 'btn-redirect-login',
      dataE2e: 'btn-redirect-login',
      color: 'primary',
      disabled: this.isLoading,
      enableBorder: true,
      type: 'button',
      responsive: true,
      actions: () => this.login(),
    }
  }

  public readonly buttonLoginBackoffice: GenericButtonProperties = {
    ...this.buttonLogin,
    label: 'Login',
  };

  public readonly buttonFirstAccess: GenericButtonProperties = {
    label: 'Concluir a criação de acesso',
    classIcon: 'ico-first-access',
    iconPosition: 'left',
    idHtml: 'btn-redirect-first-access',
    dataE2e: 'btn-redirect-first-access',
    color: 'secundary',
    disabled: this.isLoading,
    enableBorder: true,
    type: 'button',
    responsive: true,
    actions: () => this.firstAccess(),
  }

  constructor(private readonly authService: AuthService,
              private readonly router: Router,
              private readonly aRoute: ActivatedRoute,
              private readonly notifyService: NotifyService) {
  }

  ngOnInit(): void {
    this.isAtendimentoRoute = this.aRoute.snapshot.data.isBackofficeRoute || false;
    this.isTestEnv = this.aRoute.snapshot.data.isTestEnv;
  }

  private getInputValue(): string {
    return this.inputIdentify?.nativeElement?.value;
  }

  private validateRouteTest(): boolean {
    const urlSegment = new Set(this.aRoute.snapshot.url.map(segment => segment.path));
    const inputValue: string = this.getInputValue();

    if (
      !(urlSegment.has('qa-test') && inputValue === getIdentifierTestQa())
      && !(urlSegment.has('teste-automatizado') && inputValue === getIdentifierAutomatizedTest())
    ) {
      this.notifyService.showError('Identificação de Automação', 'O valor do campo de identificação não é válido.');
      this.router.navigate(['/login/bem-vindo']);
      return false;
    }

    return true;
  }

  login() {
    this.isLoading = true;
    localStorage.setItem('provider', this.aRoute.snapshot.data.ssoIdentifier);

    if (this.isTestEnv && !this.validateRouteTest()) return;

    this.authService.startLoginFlow();
  }

  public firstAccess() {
    this.router.navigate(['/primeiro-acesso']);
  }

}
